import { render } from "./listForRecord.vue?vue&type=template&id=143e5226&scoped=true&ts=true"
import script from "./listForRecord.vue?vue&type=script&lang=ts&config=true"
export * from "./listForRecord.vue?vue&type=script&lang=ts&config=true"

import "./listForRecord.vue?vue&type=style&index=0&id=143e5226&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143e5226"]])

export default __exports__